module.exports = __webpack_public_path__ + "img/not-authorized-dark.0eb44f46.svg";